var ESessionState = /*#__PURE__*/ function(ESessionState) {
    ESessionState[ESessionState["Initial"] = 0] = "Initial";
    ESessionState[ESessionState["None"] = 1] = "None";
    ESessionState[ESessionState["Stored"] = 2] = "Stored";
    return ESessionState;
}(ESessionState || {});
export { ESessionState };
